import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';

export default class MaskClientDetailHelper extends Helper {
  @service access;

  compute([permission, detail]) {
    if (!detail) return '';

    if (this.access.hasPermission(permission)) {
      return detail;
    }

    return htmlSafe('&bull;'.repeat(detail.length));
  }
}
